import { houseSearchType, typeIds } from '@lib/config'
import { getCategoryName, formatPrice } from '@lib/utils'
import { isArray } from 'lodash-es'

export function checkSubcribe(type) {
  return [
    houseSearchType.estimate, 
    houseSearchType.sold
  ].indexOf(type) === -1
}

/**
 * type: 当前搜索列表的类型  config.js houseSearchType
 * ts => useTransations('search')
 * tm => useTransations('menu')
 */
export function getSubcribeOptions({ type, searchParam, tm, ts }) {
  const options = []
  
  if(!searchParam) return options
  
  // 类型
  if(type) {
    const typeName = getCategoryName(type, tm)
    if(typeName) {
      options.push({ 
        label: typeName,
        prop: 'type', 
        value: typeIds[type], 
        closable: false 
      })
    }
  }

  // 卧室、浴室、车位
  ['bedroom', 'bathroom', 'carspace'].forEach((prop) => {
    if(searchParam[prop]?.length > 0) {
      const value = searchParam[prop].join(',')
      options.push({ 
        label: `${ts(`${prop}s`)}: ${value}`, prop, value 
      })
    }
  })

  // 价格
  const prices = isArray(searchParam.price) ? searchParam.price : []
  const len = prices.length

  if(len > 0) {
    const label = len === 1
      ? `$${formatPrice(prices[0])}`
      : `$${formatPrice(prices[0])}-$${formatPrice(prices[1])}`
    
    options.push({ label, prop: 'price' })
  }

  return options
}
